module.exports = __webpack_public_path__ + "img/img08.8152a360.png";